module.exports = __webpack_public_path__ + "static/loggedOut-fb509d974e7ddef1847f2808df50eca4.jpg";